    import React from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, { apiCall, formattedPrice } from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import Swal from "sweetalert2";
import withPermissions from "../../components/WithPermissions";
import subscriptionPermissionsControl from "../../components/SubscriptionPermissionsControl";
import ReactDOMServer from "react-dom/server";

class ManualInvoiceDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      invoice: null,
      items: [],
      formData: {
        due_date: '',
        payment_status: 'unpaid',
      },
      isLoad: true,
      sendingInvoice: false,
      savingCari: false,
      deletingInvoice: false,
    };
  }

  componentDidMount() {
    this.getInvoiceDetail();
  }

  getInvoiceDetail = async () => {
    const invoiceId = this.props.match.params.id;
    this.setState({ isLoad: true });

    try {
      const response = await apiCall(`business/manual-invoice/${invoiceId}`, 'get', null);
      
      this.setState({
        invoice: response.data,
        items: response.data.items || [],
        formData: {
          due_date: response.data.due_date || '',
          payment_status: response.data.payment_status || 'unpaid',
        },
        isLoad: false,
      });
    } catch (error) {
      console.error("Error fetching invoice detail:", error);
      this.setState({ isLoad: false });
      mainHelper.toastMessage('error', 'Fatura detayı yüklenirken hata oluştu!');
      this.props.history.push('/manual-invoices');
    }
  };

  handleChange = (e) => {
    const { id, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [id]: value
      }
    }));
  };

  handleSaveCari = async () => {
    const { formData } = this.state;

    if (!formData.due_date || !formData.payment_status) {
      Swal.fire(
        'Dikkat!',
        'Lütfen vade tarihi ve tahsilat durumunu doldurduğunuzdan emin olun!',
        'warning'
      );
      return;
    }

    const result = await Swal.fire({
      title: 'Uyarı',
      text: "Onaylandığında mevcut toplam tutar üzerinden bir cari kaydı oluşturulacaktır. Cari kayıt mevcut ise ilgili alanlar güncellenecektir." +
        " Not: Ödendi olarak kaydedilir ise alacak tutarı 0 olarak güncellenir.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Kaydet!',
      cancelButtonText: 'İptal et',
      preConfirm: async () => {
        const confirmButton = Swal.getConfirmButton();
        const originalButtonText = confirmButton.innerHTML;
        confirmButton.disabled = true;
        confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

        try {
          await apiCall(`business/manual-invoice/cari/save/${this.state.invoice.id}`, 'post', formData);
          return true;
        } catch (error) {
          return false;
        } finally {
          confirmButton.innerHTML = originalButtonText;
          confirmButton.disabled = false;
        }
      }
    });

    if (result.isConfirmed) {
      if (result.value) {
        Swal.fire(
          'Uyarı!',
          'İşlem başarıyla güncellendi.',
          'success'
        );
        await this.getInvoiceDetail();
      } else {
        Swal.fire(
          'Hata!',
          'İşlem başarısız oldu.',
          'error'
        );
      }
    }
  };

  handleSendInvoice = async () => {
    const { invoice } = this.state;

    const result = await Swal.fire({
      title: 'Faturayı Resmileştir',
      html: `
        <div style="text-align: left;">
          <p><strong>Faturayı resmileştirmek üzeresiniz.</strong></p>
          <hr />
          <p style="color: #666; font-size: 14px;">
            <i class="icon-info"></i>
            Fatura müşteriye gönderilecek ve sistem tarafından kaydedilecektir.
          </p>
          <p style="color: #d33; font-size: 14px;">
            <i class="icon-exclamation"></i>
            <strong>Uyarı:</strong> Bu işlem geri alınamaz!
          </p>
        </div>
      `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '<i class="fa fa-send"></i> Evet, Resmileştir!',
      cancelButtonText: 'İptal',
      preConfirm: async () => {
        const confirmButton = Swal.getConfirmButton();
        const originalButtonText = confirmButton.innerHTML;
        confirmButton.disabled = true;
        confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

        try {
          const response = await apiCall(`business/manual-invoice/send/${invoice.id}`, 'post', null);
          await this.getInvoiceDetail();
          return { success: true, message: response.message };
        } catch (error) {
          // Backend'den gelen detaylı hata mesajını göster
          const errorData = error.response?.data;
          let errorMessage = errorData?.message || 'Bir hata oluştu';
          
          // Eksik alanlar varsa listele
          if (errorData?.missing_fields && Array.isArray(errorData.missing_fields)) {
            errorMessage += '\n\nEksik Bilgiler:\n' + errorData.missing_fields.map(field => `• ${field}`).join('\n');
          }
          
          return { success: false, message: errorMessage };
        } finally {
          confirmButton.innerHTML = originalButtonText;
          confirmButton.disabled = false;
        }
      }
    });

    if (result.isConfirmed && result.value) {
      if (result.value.success) {
        Swal.fire({
          title: 'Başarılı!',
          text: result.value.message,
          icon: 'success',
          confirmButtonText: 'Tamam'
        });
      } else {
        Swal.fire({
          title: 'Hata!',
          html: `<pre style="text-align: left; white-space: pre-wrap;">${result.value.message}</pre>`,
          icon: 'error',
          confirmButtonText: 'Tamam'
        });
      }
    }
  };

  handleDeleteInvoice = async () => {
    const result = await Swal.fire({
      title: 'Silmek istediğinize emin misiniz?',
      text: "Bu işlem geri alınamaz!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet, sil!',
      cancelButtonText: 'Hayır, iptal et',
      preConfirm: async () => {
        const confirmButton = Swal.getConfirmButton();
        const originalButtonText = confirmButton.innerHTML;
        confirmButton.disabled = true;
        confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

        try {
          await apiCall(`business/manual-invoice/${this.state.invoice.id}`, 'delete', null);
          window.location.href = `${process.env.PUBLIC_URL}/manual-invoices`;
          return true;
        } catch (error) {
          return false;
        } finally {
          confirmButton.innerHTML = originalButtonText;
          confirmButton.disabled = false;
        }
      }
    });

    if (result.isConfirmed) {
      if (result.value) {
        Swal.fire(
          'Silindi!',
          'Fatura başarıyla silindi.',
          'success'
        );
      } else {
        Swal.fire(
          'Hata!',
          'Silme işlemi başarısız oldu.',
          'error'
        );
      }
    }
  };

  openCustomerDetail = (e) => {
    e.preventDefault();
    const link = `${process.env.PUBLIC_URL}/customer-detail/${this.state.invoice.customer_id}`;
    window.open(link, "_blank");
  };

  calculateTotals = () => {
    const { invoice, items } = this.state;

    if (!invoice) {
      return {
        totalAmount: 0,
        totalVat: 0,
        totalDiscount: 0,
        netTotal: 0,
        withholdingRate: 0,
        totalWithholding: 0
      };
    }

    // withholding_info JSON array olabilir, object olabilir ya da null olabilir
    let withholdingInfo = {};
    if (Array.isArray(invoice.withholding_info) && invoice.withholding_info.length > 0) {
      withholdingInfo = invoice.withholding_info[0];
    } else if (invoice.withholding_info && typeof invoice.withholding_info === 'object') {
      withholdingInfo = invoice.withholding_info;
    }

    const withholdingRate = invoice.withholding_rate || withholdingInfo.rate || 0;
    const totalWithholding = invoice.total_withholding || 0;

    return {
      totalAmount: invoice.total_amount,
      totalVat: invoice.total_vat,
      totalDiscount: invoice.total_discount,
      netTotal: invoice.net_total,
      withholdingRate: withholdingRate,
      totalWithholding: totalWithholding
    };
  };

  render() {
    const { invoice, items, formData, isLoad, sendingInvoice, savingCari, deletingInvoice } = this.state;
    const { userPermissions, subscriptionCode } = this.props;
    const userHasCreateInvoice = userPermissions.includes('invoice process');
    const code = subscriptionCode !== "none" && subscriptionCode !== "t22Vh3S";
    const { totalAmount, totalVat, totalDiscount, netTotal, withholdingRate, totalWithholding } = this.calculateTotals();

    if (isLoad) {
      return (
        <div className="page-loader-wrapper" style={{ display: 'block' }}>
          <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className="m-t-30">
              <img src={require('../../assets/images/logo-white.png')} width="150" alt="Servicezone" />
            </div>
            <p>Yükleniyor</p>
            <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
          </div>
        </div>
      );
    }

    if (!invoice) {
      return (
        <div className="container-fluid">
          <div className="alert alert-danger">Fatura bulunamadı!</div>
        </div>
      );
    }

    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Manuel Fatura Detayları"
              Breadcrumb={[
                { name: "Manuel Faturalar", navigate: "manual-invoices" },
                { name: "Detay", navigate: "" },
              ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card" style={{borderRadius: '8px'}}>
                  <div>
                    {invoice && (
                      <div className="body" style={{padding: '20px'}}>
                        <div className="d-flex justify-content-between align-items-center flex-wrap" style={{marginBottom: '20px'}}>
                          <h4 style={{color: "#333", fontWeight: "600", margin: 0}}>
                            Fatura No: <span className="text-cyan">{invoice.invoice_number}</span>
                          </h4>
                          <div className="d-flex align-items-center" style={{gap: '10px'}}>
                            <span className={`badge ${invoice.status === 'draft' ? 'badge-secondary' :
                                    invoice.status === 'running' ? 'badge-primary' :
                                        invoice.status === 'done' ? 'badge-success' :
                                            invoice.status === 'error' ? 'badge-danger' :
                                                invoice.status === 'cancel' ? 'badge-danger' : 'badge-warning'
                                }`}
                                  style={{fontSize: '13px', padding: '6px 12px'}}>
                              <i className={`fa ${invoice.status === 'draft' ? 'fa-file-text-o' :
                                  invoice.status === 'running' ? 'fa-spinner' :
                                      invoice.status === 'done' ? 'fa-check' :
                                          invoice.status === 'error' ? 'fa-exclamation-triangle' :
                                              invoice.status === 'cancel' ? 'fa-times' : 'fa-question'
                                  }`}></i>
                              &nbsp;{invoice.status === 'draft' ? 'Taslak' :
                                  invoice.status === 'running' ? 'İşlemde' :
                                      invoice.status === 'done' ? 'Resmileşti' :
                                          invoice.status === 'error' ? 'Hata' :
                                              invoice.status === 'cancel' ? 'İptal' : 'Bilinmeyen'}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="body" style={{padding: '20px'}}>
                      {invoice && (
                        <div className="row">
                          {/* Fatura Bilgileri */}
                          <div className="col-lg-12 col-md-12 mb-3">
                            <div style={{padding: '15px', background: '#f8f9fa', borderRadius: '8px'}}>
                              <h6 className="text-cyan font-weight-bold mb-3">Fatura Bilgileri</h6>
                              <div style={{display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px"}}>
                                <div>
                                  <small className="text-muted d-block" style={{fontSize: '12px', fontWeight: '600'}}>Fatura No</small>
                                  <strong style={{fontSize: '14px'}}>{invoice.invoice_number}</strong>
                                </div>
                                <div>
                                  <small className="text-muted d-block" style={{fontSize: '12px', fontWeight: '600'}}>Fatura Tarihi</small>
                                  <strong style={{fontSize: '14px'}}>{mainHelper.dateOnlyFormat(invoice.invoice_date)}</strong>
                                </div>
                                <div>
                                  <small className="text-muted d-block" style={{fontSize: '12px', fontWeight: '600'}}>Fatura Tipi</small>
                                  <strong style={{fontSize: '14px'}}>
                                    Manuel Fatura 
                                    {(() => {
                                      // Müşteri varsa invoice_type'dan al
                                      if (invoice.customer && invoice.customer.invoice_type === 'EFATURA') {
                                        return <span style={{color: '#17a2b8'}}> (E-Fatura)</span>;
                                      }
                                      if (invoice.customer && invoice.customer.invoice_type !== 'EFATURA') {
                                        return <span style={{color: '#17a2b8'}}> (E-Arşiv)</span>;
                                      }
                                      // Müşteri yoksa fatura numarasından prefix'e bak (MEF: E-Fatura, MEA: E-Arşiv)
                                      const prefix = invoice.invoice_number ? invoice.invoice_number.substring(0, 3) : '';
                                      if (prefix === 'MEF') {
                                        return <span style={{color: '#17a2b8'}}> (E-Fatura)</span>;
                                      }
                                      if (prefix === 'MEA') {
                                        return <span style={{color: '#17a2b8'}}> (E-Arşiv)</span>;
                                      }
                                      return null;
                                    })()}
                                  </strong>
                                </div>
                                <div>
                                  <small className="text-muted d-block" style={{fontSize: '12px', fontWeight: '600'}}>Durum</small>
                                  <span className={`badge ${invoice.status === 'draft' ? 'badge-secondary' :
                                          invoice.status === 'running' ? 'badge-primary' :
                                              invoice.status === 'done' ? 'badge-success' :
                                                  invoice.status === 'error' ? 'badge-danger' :
                                                      invoice.status === 'cancel' ? 'badge-danger' : 'badge-warning'
                                      }`}
                                        style={{fontSize: '12px', padding: '4px 8px'}}>
                                    {invoice.status === 'draft' ? 'Taslak' :
                                        invoice.status === 'running' ? 'İşlemde' :
                                            invoice.status === 'done' ? 'Resmileşti' :
                                                invoice.status === 'error' ? 'Hata' :
                                                    invoice.status === 'cancel' ? 'İptal' : 'Bilinmeyen'}
                                  </span>
                                </div>
                                {invoice.document_uuid && (
                                  <div style={{gridColumn: '1 / -1'}}>
                                    <small className="text-muted d-block" style={{fontSize: '12px', fontWeight: '600'}}>Fatura UUID</small>
                                    <strong style={{fontSize: '13px', wordBreak: 'break-all'}}>{invoice.document_uuid}</strong>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Müşteri Bilgileri Kartı */}
                <div className="card" style={{borderRadius: '8px'}}>
                  <div className="body" style={{ padding: '20px' }}>
                    <h6 className="text-cyan font-weight-bold mb-3">
                      <i className="fa fa-user"></i> Müşteri Bilgileri
                    </h6>
                    <div>
                      {(() => {
                        // Önce customer relation'dan bilgileri al (GÜNCEL BİLGİLER)
                        // Yoksa cache'den al (SİLİNEN MÜŞTERLER İÇİN)
                        const customer = invoice.customer || {};
                        const isDeleted = !invoice.customer; // Müşteri silinmiş mi?
                        
                        // Hangi kaynaktan bilgi alınacak
                        const customerData = isDeleted ? {
                          name: invoice.customer_name,
                          surname: invoice.customer_surname,
                          title: invoice.customer_title,
                          tax_no: invoice.customer_tax_no,
                          tax_district: invoice.customer_tax_district,
                          address: invoice.customer_address,
                          city: invoice.customer_city,
                          district: invoice.customer_district,
                          phone: invoice.customer_phone,
                          email: invoice.customer_email,
                          urn: invoice.customer_urn,
                        } : {
                          name: customer.name,
                          surname: customer.surname,
                          title: customer.title,
                          tax_no: customer.tax_no,
                          tax_district: customer.tax_district,
                          address: customer.address,
                          city: customer.city?.name || customer.city,
                          district: customer.district?.name || customer.district,
                          phone: customer.phone,
                          email: customer.email,
                          urn: customer.urn,
                        };
                        
                        return (
                          <div style={{
                            background: '#f8f9fa',
                            borderRadius: '8px',
                            padding: '25px',
                            border: '1px solid #dee2e6'
                          }}>
                            <div className="media">
                              <div className="media-left m-r-15">
                                <div style={{
                                  width: '80px',
                                  height: '80px',
                                  borderRadius: '50%',
                                  overflow: 'hidden',
                                  border: '3px solid #dee2e6',
                                  background: '#fff'
                                }}>
                                  <img
                                    alt="User"
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    src={`https://ui-avatars.com/api/?name=${customerData.name}&color=fff&background=6c757d&size=80&font-size=0.4`}
                                  />
                                </div>
                              </div>
                              <div className="media-body" style={{ fontSize: '14px', lineHeight: '1.8' }}>
                              {isDeleted && (
                                <div style={{
                                  background: '#fff3cd',
                                  border: '2px solid #ffc107',
                                  borderRadius: '8px',
                                  padding: '12px 15px',
                                  marginBottom: '15px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px'
                                }}>
                                  <i className="fa fa-exclamation-triangle" style={{ color: '#856404', fontSize: '18px' }}></i>
                                  <span style={{ color: '#856404', fontSize: '13px' }}>
                                    <strong>Not:</strong> Bu müşteri silinmiş. Fatura tarihindeki bilgiler gösteriliyor.
                                  </span>
                                </div>
                              )}
                              
                              <div style={{ marginBottom: '15px' }}>
                                <h6 style={{ color: '#495057', fontSize: '18px', fontWeight: '700', marginBottom: '5px' }}>
                                  {customerData.name} {customerData.surname}
                                </h6>
                                {customerData.title && (
                                  <p style={{ color: '#6c757d', fontSize: '14px', margin: 0 }}>{customerData.title}</p>
                                )}
                              </div>
                              
                              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '12px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                  <i className="fa fa-id-card" style={{ color: '#6c757d', fontSize: '16px', width: '20px' }}></i>
                                  <div>
                                    <small style={{ color: '#6c757d', display: 'block', fontSize: '12px', fontWeight: '600' }}>Vergi/TC No</small>
                                    <strong style={{ color: '#495057' }}>{customerData.tax_no || 'Yok'}</strong>
                                  </div>
                                </div>
                                {customerData.tax_district && (
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <i className="fa fa-building" style={{ color: '#6c757d', fontSize: '16px', width: '20px' }}></i>
                                    <div>
                                      <small style={{ color: '#6c757d', display: 'block', fontSize: '12px', fontWeight: '600' }}>Vergi Dairesi</small>
                                      <strong style={{ color: '#495057' }}>{customerData.tax_district}</strong>
                                    </div>
                                  </div>
                                )}
                                {(customerData.city || customerData.district) && (
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <i className="fa fa-map-marker" style={{ color: '#6c757d', fontSize: '16px', width: '20px' }}></i>
                                    <div>
                                      <small style={{ color: '#6c757d', display: 'block', fontSize: '12px', fontWeight: '600' }}>Şehir/İlçe</small>
                                      <strong style={{ color: '#495057' }}>{customerData.city || '-'} / {customerData.district || '-'}</strong>
                                    </div>
                                  </div>
                                )}
                                {customerData.phone && (
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <i className="fa fa-phone" style={{ color: '#6c757d', fontSize: '16px', width: '20px' }}></i>
                                    <div>
                                      <small style={{ color: '#6c757d', display: 'block', fontSize: '12px', fontWeight: '600' }}>Telefon</small>
                                      <strong style={{ color: '#495057' }}>{customerData.phone}</strong>
                                    </div>
                                  </div>
                                )}
                                {customerData.email && (
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <i className="fa fa-envelope" style={{ color: '#6c757d', fontSize: '16px', width: '20px' }}></i>
                                    <div>
                                      <small style={{ color: '#6c757d', display: 'block', fontSize: '12px', fontWeight: '600' }}>E-posta</small>
                                      <strong style={{ color: '#495057', fontSize: '13px', wordBreak: 'break-all' }}>{customerData.email}</strong>
                                    </div>
                                  </div>
                                )}
                              </div>
                              
                              {customerData.address && (
                                <div style={{ 
                                  marginTop: '15px', 
                                  paddingTop: '15px', 
                                  borderTop: '1px solid #dee2e6',
                                  display: 'flex',
                                  gap: '10px'
                                }}>
                                  <i className="fa fa-home" style={{ color: '#6c757d', fontSize: '16px', marginTop: '2px' }}></i>
                                  <div>
                                    <small style={{ color: '#6c757d', display: 'block', fontSize: '12px', fontWeight: '600' }}>Adres</small>
                                    <span style={{ color: '#495057', fontSize: '13px' }}>{customerData.address}</span>
                                  </div>
                                </div>
                              )}
                              
                              {customerData.urn && (
                                <div style={{ 
                                  marginTop: '12px',
                                  background: '#fff',
                                  padding: '10px',
                                  borderRadius: '6px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  border: '1px solid #dee2e6'
                                }}>
                                  <i className="fa fa-barcode" style={{ color: '#6c757d', fontSize: '16px' }}></i>
                                  <div>
                                    <small style={{ color: '#6c757d', display: 'block', fontSize: '12px', fontWeight: '600' }}>URN</small>
                                    <code style={{ 
                                      fontSize: '11px', 
                                      background: '#e9ecef', 
                                      padding: '4px 8px', 
                                      borderRadius: '4px',
                                      color: '#495057'
                                    }}>{customerData.urn}</code>
                                  </div>
                                </div>
                              )}
                            </div>
                              <div style={{ marginTop: '20px', textAlign: 'right' }}>
                                {!isDeleted && (
                                  <a onClick={this.openCustomerDetail} href="#!"
                                    className="btn btn-primary"
                                    style={{
                                      padding: '10px 25px',
                                      fontSize: '14px',
                                      fontWeight: '600'
                                    }}
                                    title="Müşteri Detayına Git">
                                    <i className="fa fa-external-link"></i> Müşteri Detay
                                  </a>
                                )}
                                {isDeleted && (
                                  <button 
                                    disabled 
                                    style={{
                                      background: '#6c757d',
                                      border: 'none',
                                      color: '#fff',
                                      padding: '10px 25px',
                                      borderRadius: '20px',
                                      fontSize: '14px',
                                      fontWeight: '600',
                                      cursor: 'not-allowed',
                                      opacity: 0.7
                                    }}
                                    title="Müşteri silinmiş">
                                    <i className="fa fa-ban"></i> Müşteri Silinmiş
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })()}
                    </div>
                  </div>
                </div>

                {/* Ödeme Bilgileri Kartı */}
                <div className="card" style={{borderRadius: '8px'}}>
                  <div className="body" style={{padding: '20px', background: '#f8f9fa'}}>
                    <h6 className="text-cyan font-weight-bold mb-3">
                      <i className="fa fa-credit-card"></i> Ödeme Bilgileri
                    </h6>
                    <div style={{background: '#fff', padding: '20px', borderRadius: '8px'}}>
                    
                    <div className="row clearfix">
                      <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <label htmlFor="due_date" className="font-weight-bold text-cyan" style={{fontSize: '13px'}}>
                            Vade Tarihi
                          </label>
                          <input
                            name="due_date"
                            id="due_date"
                            className="form-control"
                            type="date"
                            value={formData.due_date}
                            onChange={this.handleChange}
                            style={{
                              borderRadius: '6px',
                              border: '1px solid #ced4da',
                              height: '44px',
                              fontSize: '14px'
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12">
                        <div className="form-group">
                          <label htmlFor="payment_status" className="font-weight-bold text-cyan" style={{fontSize: '13px'}}>
                            Tahsilat Durumu
                          </label>
                          <select
                            name="payment_status"
                            id='payment_status'
                            className="form-control"
                            value={formData.payment_status}
                            onChange={this.handleChange}
                            style={{
                              borderRadius: '6px',
                              border: '1px solid #ced4da',
                              height: '44px',
                              fontSize: '14px'
                            }}>
                            <option value="">Seçiniz</option>
                            <option value="paid">Ödendi</option>
                            <option value="unpaid">Ödenmedi</option>
                          </select>
                        </div>
                      </div>
                      <div className="hidden-print col-md-12 text-right">
                        <hr style={{ borderColor: '#dee2e6', margin: '25px 0' }} />
                        <button
                          disabled={!userHasCreateInvoice}
                          onClick={this.handleSaveCari}
                          className="btn btn-info"
                          style={{
                            padding: '12px 30px',
                            fontSize: '14px',
                            fontWeight: '600',
                            borderRadius: '6px'
                          }}
                        >
                          <i className="fa fa-save" style={{ marginRight: '8px' }}></i>
                          Kaydet
                        </button>
                      </div>
                    </div>
                    </div>
                  </div>
                </div>

                {/* Fatura Kalemleri Kartı */}
                <div className="card" style={{borderRadius: '8px'}}>
                  <div className="body" style={{ padding: '20px' }}>
                    <h6 className="text-cyan font-weight-bold mb-3">
                      <i className="fa fa-list"></i> Fatura Kalemleri
                    </h6>
                    
                    <div className="row clearfix">
                      <div className="col-lg-12">
                        {items && items.length > 0 && items.map((item, index) => (
                          <div key={index} className="form-row align-items-end mb-3" style={{
                            background: '#fff',
                            padding: '20px',
                            borderRadius: '8px',
                            border: '2px solid #dee2e6',
                            marginBottom: '15px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                          }}>
                            <div className="col-lg">
                              <label htmlFor={`process`} className="font-weight-bold text-cyan">Ürün/Hizmet</label>
                              <input
                                type="text"
                                className="form-control"
                                id={`process`}
                                placeholder="Ürün/Hizmet"
                                value={item.product_service_name}
                                readOnly
                                style={{
                                  borderRadius: '6px',
                                  border: '1px solid #ced4da',
                                  height: '44px',
                                  fontSize: '14px'
                                }}
                              />
                            </div>

                            <div className="col-lg">
                              <label htmlFor={`unit`} className="font-weight-bold text-cyan">Birim</label>
                              <select
                                id={`unit`}
                                className="form-control"
                                value={item.unit}
                                disabled
                                style={{
                                  borderRadius: '6px',
                                  border: '1px solid #ced4da',
                                  height: '44px',
                                  fontSize: '14px'
                                }}>
                                <option value="">Birim</option>
                                <option value="C62">Adet</option>
                                <option value="KGM">Kg</option>
                                <option value="LTR">Litre</option>
                                <option value="MTR">Metre</option>
                                <option value="MTK">Metre Kare</option>
                                <option value="MTQ">Metre Küp</option>
                                <option value="PR">Çift</option>
                              </select>
                            </div>

                            <div className="col-lg">
                              <label htmlFor={`quantity`} className="font-weight-bold text-cyan">Miktar</label>
                              <input
                                type="number"
                                className="form-control"
                                id={`quantity`}
                                placeholder="Miktar"
                                value={item.quantity}
                                readOnly
                                style={{
                                  borderRadius: '6px',
                                  border: '1px solid #ced4da',
                                  height: '44px',
                                  fontSize: '14px'
                                }}
                              />
                            </div>
                            <div className="col-lg">
                              <label htmlFor={`kdv`} className="font-weight-bold text-cyan">KDV (%)</label>
                              <input
                                type="number"
                                className="form-control"
                                id={`kdv`}
                                placeholder="KDV Oranı"
                                value={item.vat_rate}
                                readOnly
                                style={{
                                  borderRadius: '6px',
                                  border: '1px solid #ced4da',
                                  height: '44px',
                                  fontSize: '14px'
                                }}
                              />
                            </div>
                            <div className="col-lg">
                              <label htmlFor={`discount`} className="font-weight-bold text-cyan">İndirim (%)</label>
                              <input
                                type="number"
                                className="form-control"
                                id={`discount`}
                                placeholder="İndirim Oranı"
                                value={item.discount_rate}
                                readOnly
                                style={{
                                  borderRadius: '6px',
                                  border: '1px solid #ced4da',
                                  height: '44px',
                                  fontSize: '14px'
                                }}
                              />
                            </div>
                            <div className="col-lg">
                              <label htmlFor={`price`} className="font-weight-bold text-cyan">Tutar (₺)</label>
                              <input
                                type="number"
                                className="form-control"
                                id={`price`}
                                placeholder="Tutar"
                                value={item.unit_price}
                                readOnly
                                style={{
                                  borderRadius: '6px',
                                  border: '1px solid #ced4da',
                                  height: '44px',
                                  fontSize: '14px'
                                }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="row clearfix" style={{ marginTop: '30px' }}>
                      <div className="col-md-12">
                        <div style={{
                          background: '#f8f9fa',
                          border: '2px solid #dee2e6',
                          borderRadius: '8px',
                          padding: '20px'
                        }}>
                          <label className="font-weight-bold text-cyan" style={{ marginBottom: '12px', display: 'block' }}>
                            Fatura Açıklaması
                          </label>
                          <div style={{
                            background: '#fff',
                            borderRadius: '6px',
                            padding: '15px',
                            color: '#495057',
                            fontSize: '14px',
                            lineHeight: '1.6',
                            minHeight: '60px',
                            border: '1px solid #dee2e6'
                          }}>
                            {invoice.description || 'Açıklama bulunmuyor'}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row clearfix" style={{ marginTop: '30px' }}>
                      <div className="col-lg-8 col-md-12">
                        {/* Boş alan - sol taraf */}
                      </div>
                      <div className="col-lg-4 col-md-12">
                        <div style={{
                          background: '#fff',
                          padding: '20px',
                          borderRadius: '8px',
                          border: '2px solid #dee2e6',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                        }}>
                          <div style={{ 
                            marginBottom: '15px',
                            paddingBottom: '10px',
                            borderBottom: '2px solid #e9ecef'
                          }}>
                            <h6 className="font-weight-bold text-cyan" style={{ margin: 0, fontSize: '13px' }}>
                              <i className="fa fa-calculator" style={{ marginRight: '8px' }}></i>
                              Fiyat Özeti
                            </h6>
                          </div>

                          {/* Hesap Kalemleri */}
                          <div style={{ marginBottom: '15px' }}>
                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              padding: '8px 0',
                              borderBottom: '1px solid #f0f0f0',
                              fontSize: '13px'
                            }}>
                              <span style={{ color: '#6c757d' }}>Ara Toplam</span>
                              <span style={{ fontWeight: '600', color: '#495057' }}>{formattedPrice(totalAmount)}</span>
                            </div>

                            {totalVat > 0 && (
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                padding: '8px 0',
                                borderBottom: '1px solid #f0f0f0',
                                fontSize: '13px'
                              }}>
                                <span style={{ color: '#6c757d' }}>KDV</span>
                                <span style={{ fontWeight: '600', color: '#28a745' }}>+ {formattedPrice(totalVat)}</span>
                              </div>
                            )}

                            {totalDiscount > 0 && (
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                padding: '8px 0',
                                borderBottom: '1px solid #f0f0f0',
                                fontSize: '13px'
                              }}>
                                <span style={{ color: '#6c757d' }}>İndirim</span>
                                <span style={{ fontWeight: '600', color: '#ffc107' }}>- {formattedPrice(totalDiscount)}</span>
                              </div>
                            )}

                            {totalWithholding > 0 && (
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                padding: '8px 0',
                                borderBottom: '1px solid #f0f0f0',
                                fontSize: '13px'
                              }}>
                                <span style={{ color: '#6c757d' }}>Tevkifat ({withholdingRate}%)</span>
                                <span style={{ fontWeight: '600', color: '#dc3545' }}>- {formattedPrice(totalWithholding)}</span>
                              </div>
                            )}
                          </div>

                          {/* Genel Toplam */}
                          <div style={{
                            background: '#007bff',
                            padding: '15px',
                            borderRadius: '6px',
                            textAlign: 'center'
                          }}>
                            <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.9)', marginBottom: '5px', fontWeight: '600' }}>
                              GENEL TOPLAM
                            </div>
                            <div style={{ fontSize: '24px', fontWeight: '700', color: '#fff' }}>
                              {formattedPrice(netTotal)}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-12 d-flex justify-content-end" style={{ marginTop: '30px' }}>
                        <div className="hidden-print col-md-12 text-center">
                          <hr style={{ borderColor: '#dee2e6', margin: '30px 0' }} />
                          {invoice ? (
                            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
                              {/* DRAFT: Tüm butonlar (Sil, Resmileştir) */}
                              {invoice.status === "draft" && (
                                <>
                                  {deletingInvoice ? (
                                    <button 
                                      className="btn btn-danger"
                                      disabled
                                      style={{
                                        padding: '12px 30px',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        borderRadius: '6px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '10px'
                                      }}>
                                      <ReactLoading type="spin" width={'20px'} height={'20px'} color="#ffffff" />
                                      Siliniyor...
                                    </button>
                                  ) : (
                                    <button
                                      disabled={!userHasCreateInvoice}
                                      onClick={this.handleDeleteInvoice}
                                      className="btn btn-outline-danger"
                                      style={{
                                        padding: '12px 30px',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        borderRadius: '6px'
                                      }}>
                                      <i className="fa fa-trash" style={{ marginRight: '8px' }}></i>
                                      Faturayı Sil
                                    </button>
                                  )}

                                  {sendingInvoice ? (
                                    <button 
                                      className="btn btn-success"
                                      disabled
                                      style={{
                                        padding: '12px 30px',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        borderRadius: '6px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '10px'
                                      }}>
                                      <ReactLoading type="spin" width={'20px'} height={'20px'} color="#ffffff" />
                                      Gönderiliyor...
                                    </button>
                                  ) : (
                                    <button
                                      disabled={!userHasCreateInvoice || !code}
                                      onClick={this.handleSendInvoice}
                                      className="btn btn-success"
                                      style={{
                                        padding: '12px 30px',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        borderRadius: '6px'
                                      }}>
                                      <i className="fa fa-paper-plane" style={{ marginRight: '8px' }}></i>
                                      Faturayı Gönder (Resmileştir)
                                    </button>
                                  )}
                                </>
                              )}

                              {/* RUNNING */}
                              {invoice.status === "running" && (
                                <button 
                                  className="btn btn-primary"
                                  disabled
                                  style={{
                                    padding: '12px 30px',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    borderRadius: '6px'
                                  }}>
                                  <i className="fa fa-spinner" style={{ marginRight: '8px' }}></i>
                                  Fatura işlemde...
                                </button>
                              )}

                              {/* DONE */}
                              {invoice.status === "done" && (
                                <button 
                                  className="btn btn-success"
                                  disabled
                                  style={{
                                    padding: '12px 30px',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    borderRadius: '6px'
                                  }}>
                                  <i className="fa fa-check-circle" style={{ marginRight: '8px' }}></i>
                                  Fatura başarıyla gönderildi
                                </button>
                              )}

                              {/* ERROR */}
                              {invoice.status === "error" && (
                                <>
                                  <button 
                                    className="btn btn-danger"
                                    disabled
                                    style={{
                                      padding: '12px 30px',
                                      fontSize: '14px',
                                      fontWeight: '600',
                                      borderRadius: '6px'
                                    }}>
                                    <i className="fa fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
                                    Fatura işlenirken hata oluştu
                                  </button>
                                  {deletingInvoice ? (
                                    <button 
                                      className="btn btn-danger"
                                      disabled
                                      style={{
                                        padding: '12px 30px',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        borderRadius: '6px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '10px'
                                      }}>
                                      <ReactLoading type="spin" width={'20px'} height={'20px'} color="#ffffff" />
                                      Siliniyor...
                                    </button>
                                  ) : (
                                    <button
                                      disabled={!userHasCreateInvoice}
                                      onClick={this.handleDeleteInvoice}
                                      className="btn btn-outline-danger"
                                      style={{
                                        padding: '12px 30px',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        borderRadius: '6px'
                                      }}>
                                      <i className="fa fa-trash" style={{ marginRight: '8px' }}></i>
                                      Faturayı Sil
                                    </button>
                                  )}
                                </>
                              )}

                              {/* CANCEL */}
                              {invoice.status === "cancel" && (
                                <>
                                  <button 
                                    className="btn btn-danger"
                                    disabled
                                    style={{
                                      padding: '12px 30px',
                                      fontSize: '14px',
                                      fontWeight: '600',
                                      borderRadius: '6px'
                                    }}>
                                    <i className="fa fa-ban" style={{ marginRight: '8px' }}></i>
                                    Fatura iptal edildi
                                  </button>
                                  {deletingInvoice ? (
                                    <button 
                                      className="btn btn-danger"
                                      disabled
                                      style={{
                                        padding: '12px 30px',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        borderRadius: '6px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '10px'
                                      }}>
                                      <ReactLoading type="spin" width={'20px'} height={'20px'} color="#ffffff" />
                                      Siliniyor...
                                    </button>
                                  ) : (
                                    <button
                                      disabled={!userHasCreateInvoice}
                                      onClick={this.handleDeleteInvoice}
                                      className="btn btn-outline-danger"
                                      style={{
                                        padding: '12px 30px',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        borderRadius: '6px'
                                      }}>
                                      <i className="fa fa-trash" style={{ marginRight: '8px' }}></i>
                                      Faturayı Sil
                                    </button>
                                  )}
                                </>
                              )}
                            </div>
                          ) : (
                            <div className="alert alert-danger text-center" style={{
                              borderRadius: '12px',
                              padding: '20px',
                              background: '#f8d7da',
                              border: '2px solid #dc3545',
                              color: '#721c24'
                            }}>
                              <i className="fa fa-exclamation-triangle" style={{ fontSize: '24px', marginBottom: '10px' }}></i>
                              <br />
                              Fatura oluşturulurken bir sorun oluştu.
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default subscriptionPermissionsControl(
  withPermissions(
    withRouter(
      connect(mapStateToProps, {})(ManualInvoiceDetail)
    )
  )
);
